export default __webpack_public_path__ + "static/media/yellow-tires.3b048179.svg";